import { ReactComponent as searchIcon } from '../../../../../../icons/search.svg';
import React, { useContext, useState } from "react";
import './searchDocumentModal.scss';
import Modal from "../../../../../../components/modalWindow/modal";
import ButtonField from '../../../../../../components/buttonField/buttonField';
import { classNameBtn } from '../../../../../../components/shared/button/types/buttonProps';
import { ButtonFieldProps } from '../../../../../../components/buttonField/types/buttonFieldProps';
import { stylizationVerticalAlign } from '../../../../../../components/shared/stylization';
import { apiContext } from '../../../../../../contexts/apiContext';
import { notifyError, notifyWarn } from '../../../../../../components/snackbar/snackbar';
import { FormFieldProps } from '../../../../../../components/formField/types/formFieldProps';
import FormField from '../../../../../../components/formField/formField';
import { CellContext, createColumnHelper } from '@tanstack/react-table';
import TableActions from '../../../../../../components/shared/table/tableActions/tableActions';
import { TableProps } from '../../../../../../components/shared/table/types/tableProps';
import { HeadersTable } from '../../../../../../helpers/featureTableConstruct';
import Table from '../../../../../../components/shared/table/table';
import ConfirmModal from '../../../../../../components/modalWindow/confirmModal';
import Spinner from '../../../../../../components/spinner/spinner';
import { ClassNameSpinner } from '../../../../../../components/spinner/types/spinnerProps';
import { SearchDocumentModalProps } from './types/searchDocumentModalProps';
import { LandSlideDocuments } from '../../../../../../contexts/krFormContext';
import { QueryDocumentsProps } from '../../../../../../services/registrationCardService/types/registrationCardServiceProps';
import { queryDocuments } from '../../../../../../services/registrationCardService/registrationCardService';

const SearchDocumentModal = (props: SearchDocumentModalProps) => {
    const api = useContext(apiContext);
    const [loading, setLoading] = useState<Boolean>(false);
    const [searchFilters, setSearchFilters] = useState<any |null>({});
    const [searchResult, setSearchResult] = useState<any>([]);
    const [confirmation, setConfirmation] = useState<boolean>(false);
    const [documentRow, setDocumentRow] = useState<LandSlideDocuments>();
    const [focusTable, setFocusTable] = useState<boolean>(false);

    const refocus = () => {
        setFocusTable(true);
    }

    // Search inputs
    const getInputProps = (labelName: string, inputPlaceholder: string, inputId: string, type: string, value?: string | number | null): FormFieldProps => {
        return {
            labelName: labelName,
            inputPlaceholder: inputPlaceholder,
            type: type,
            pristine: true,
            keepPristine: true,
            setValue: (event: any) => onChangeInput(event, inputId),
            value: value === null ? "" : value
        };
    }

    const onChangeInput = (event: any, id: any) => {       
        setSearchFilters((prevData: any) => ({...prevData, [id]: event}));
    }

    // Search button
    const getBtnProps = (title: string, onClick: React.MouseEventHandler<HTMLButtonElement>): ButtonFieldProps => {
        return {
            BtnProps: {
                onClick: onClick,
                className: `${classNameBtn.Btn} ${classNameBtn.Large} body-txt-medium searchBtn`
            },
            placeHolder: title,
            placeHolderStyle: stylizationVerticalAlign,
            wrapperProps: {
                className: "searchBtnField"
            }
        };
    }
    
    // Documents search table
    const cellAction = (properties: CellContext<any, unknown>) => {
        return (<TableActions
            row={properties.row}
            objectType={"search-documents-publications"}
            addClickHandler={handleAddClick}
        />)
    }

    const handleAddClick = (row: any) => {
        setDocumentRow(row);
        setConfirmation(true);    
    }

    let headers = {
        autorzy: "Autorzy", 
        tytul: "Tytuł",         
        rok: "Rok"
    };
    var tableProps: TableProps = {
        columnAliases: headers,
        columnHelper: createColumnHelper<HeadersTable>(),
        columnNames: Object.keys(headers),
        cellActions: cellAction,
        data: searchResult,
        loading: false,
        className: "table",
        refocus: focusTable,
        setRefocusTable: setFocusTable
    }

    const searchDocument = () => {
        if (!searchFilters || (!searchFilters.AUTORZY && !searchFilters.TYTUL && !searchFilters.ROK)) {
            notifyError({ message: "Uzupełnij przynajmniej jedno pole wyszukiwania" });
        }
        else {
            setLoading(true);
            let queryDocumentsProps: QueryDocumentsProps = {
                landslideDocuments: searchFilters,
                apiBase: api.apiUrl + api.apiVersion
            }
    
            queryDocuments(queryDocumentsProps)
            .then((response: any) => {
                if (response) {
                    response.sort((a: any, b: any) => {
                        const aYear = a.rok !== null && a.rok !== undefined ? a.rok : -1;
                        const bYear = b.rok !== null && b.rok !== undefined ? b.rok : -1;
                        return bYear - aYear;
                    });
                }
                setSearchResult(response);
                setLoading(false);
                if (response.length === 0) {
                    notifyWarn({ message: "Brak podanych wartości w słownikach dokumentów"});
                }
            })
            .catch(() => {
                setLoading(false);
                notifyError({ message: "Wyszukanie dokumentu zakończone niepowodzeniem" });
            });
        }
    }

    const confirm = () => {
        setConfirmation(false);
        props.onAddDocument(documentRow);
        close();
    }

    const cancel = () => {
        setConfirmation(false);
    }

    const getQuestion = () => {
        return `Czy na pewno chcesz dodać dokument ${documentRow?.tytul}?`;
    }

    const close = () => {
        props.onClose();
        refocusToMainFormBtn();
    }

    const refocusToMainFormBtn = () => {
        if (props.refocus) props.refocus();
    }
    
    return (<Modal
        title={"Szukaj dokumentu"}
        titleIcon={searchIcon}
        iconClass='titleIcon'
        width={'1075px'}
        height={'500px'}
        onClose={close}>
        <div className='searchDocumentModalBody'>
            <div className='searchContainer'>   
                <FormField {...getInputProps("Autor", "Wpisz imię i nazwisko autora", "AUTORZY", "text", searchFilters.AUTORZY)}/>
                <FormField {...getInputProps("Tytuł", "Wpisz tytuł dokumentu", "TYTUL", "text", searchFilters.TYTUL)}/>
                <FormField {...getInputProps("Rok", "Wpisz rok dokumentu", "ROK", "number",  searchFilters.ROK)} onlyDigits={true}/>
                <ButtonField {...getBtnProps("Szukaj", () => { searchDocument() })}></ButtonField>
            </div>
            <div>
                <Table {...tableProps}/>
            </div>
        </div>
        {confirmation && 
        <ConfirmModal width={"660px"} height={"auto"}
            confirmTitle={"Tak, dodaj dokument"}
            onConfirm={confirm}
            cancelTitle={"Anuluj"}
            onCancel={cancel}
            question={getQuestion()}
            refocus={refocus}
        />}
        {loading && <div className='spinnerSearch'><Spinner spinnerClass={ClassNameSpinner.Big}/></div>}
    </Modal>);
};

export default SearchDocumentModal;